module.exports = __webpack_public_path__ + "img/ic-rampe.e87b2ca9.svg";